import { useEffect } from 'react'
import Analytics from 'react-ga4'

import { Landing } from 'website'

import 'aos/dist/aos.css'

const Home = () => {
  useEffect(() => {
    // Save page view whenever a user view this page.
    Analytics.send({
      hitType: 'pageview',
      page: '/'
    })
  }, [])

  return <Landing />
}

export default Home

export async function getStaticProps() {
  return { props: {} }
}
